/**
 * frontend/src/utils/history.js
 * Gère la synchronisation entre les steps de l'app et l'historique du navigateur.
 */

const STEP_HISTORY_KEY = 'rentalcheck_step_history'

/**
 * Pousse un nouvel état dans l'historique du navigateur sans recharger la page.
 * @param {string} step Le nom du step (home, photos, etc.)
 */
export function pushHistoryStep(step) {
  if (!step) return
  
  // Éviter de pousser le même step deux fois de suite
  if (window.history.state?.step === step) return

  console.log(`[History] Pushing step: ${step}`)
  window.history.pushState({ step }, '', `#${step}`)
}

/**
 * Initialise l'écouteur pour le bouton retour (popstate).
 * @param {Function} onBack Callback appelé avec le step précédent.
 */
export function initHistoryListener(onBack) {
  const handlePopState = (event) => {
    const step = event.state?.step
    console.log(`[History] PopState detected, target step: ${step}`)
    if (step) {
      onBack(step)
    } else {
      // Si on revient tout au début (state null), on peut forcer 'home' ou laisser faire
      onBack('home')
    }
  }

  window.addEventListener('popstate', handlePopState)
  
  // Initialiser le premier état si nécessaire
  if (!window.history.state) {
    window.history.replaceState({ step: 'home' }, '', '#home')
  }

  return () => window.removeEventListener('popstate', handlePopState)
}
